import React from 'react';
import { injectIntl } from 'react-intl';
import { Table, Column } from 'react-virtualized/dist/es/Table';
import { AutoSizer } from 'react-virtualized/dist/es/AutoSizer';
import FileIcon from 'box-ui-elements/es/icons/file-icon/FileIcon';
import type { IntlShape } from 'react-intl';
import RemoveButton from './remove-button';
import css from './item-list.module.scss';
import messages from '../messages';
import type { Item } from '../../../../types/Item';

type Props = {
  intl: IntlShape;
  isDisabled?: boolean;
  items: Array<Item>;
  onRemove: (arg1: Item) => void;
};

const ItemList = (props: Props) => {
  const { intl, items, onRemove, isDisabled } = props;
  return (
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2786
    <AutoSizer defaultHeight={280} defaultWidth={740}>
      {({ width, height }) => {
        return (
          // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2786
          <Table
            disableHeader
            gridClassName={css.table}
            headerHeight={0}
            height={height}
            rowClassName={css.row}
            rowCount={items.length}
            // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
            rowGetter={({ index }): Item => items[index]}
            rowHeight={50}
            tabIndex={-1}
            width={width}
          >
            {/*
             // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2786 */}
            <Column
              cellRenderer={({ rowData }) => {
                const { name, fileSize, extension } = rowData;
                return (
                  <div className={css.itemIconAndName}>
                    <div className={css.itemIcon}>
                      <FileIcon extension={extension} />
                    </div>
                    <div className={css.itemName}>
                      <span className={css.itemNameLabel}>{name}</span>
                      {fileSize ? (
                        <span className={css.itemFileSize}>{fileSize}</span>
                      ) : null}
                    </div>
                  </div>
                );
              }}
              dataKey="name"
              flexGrow={1}
              flexShrink={1}
              width={300}
            />
            {/*
             // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2786 */}
            <Column
              cellRenderer={({ rowData }) => {
                const { fileSize } = rowData;
                return fileSize;
              }}
              className={css.fileSizeRow}
              dataKey="fileSize"
              flexGrow={1}
              flexShrink={0}
              style={{ textAlign: 'right' }}
              width={75}
            />
            {/*
             // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2786 */}
            <Column
              cellRenderer={({ rowData }) => {
                const { name } = rowData;
                return isDisabled ? null : (
                  <RemoveButton
                    aria-label={intl.formatMessage(messages.removeFile, {
                      fileName: name,
                    })}
                    onClick={() => {
                      onRemove(rowData);
                    }}
                  />
                );
              }}
              dataKey="remove"
              flexShrink={0}
              style={{ textAlign: 'center' }}
              width={40}
            />
          </Table>
        );
      }}
    </AutoSizer>
  );
};

export { ItemList };
type WrappedProps = Omit<Props, 'intl'>;
const Wrapped = injectIntl(ItemList);
export default Wrapped as React.ComponentType<WrappedProps>;
